import axios from '../../http'

class XBPromotion {
  // 获取促销列表
  getPromotionList(currentPage) {
    const url = `/api/xb/goods/promotion/now?currentPage=${currentPage}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取预促销列表
  getPromotionNoticeList(currentPage) {
    const url = `/api/xb/goods/promotion/pre?currentPage=${currentPage}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取促销详情
  getPromotionGoodsDetail(goodsId) {
    const url = `/api/xb/goods/promotion/info?goodsId=${goodsId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBPromotion
